/* The Mint Workshop — motion.
   Scroll reveals, subgrade meter, stat counters. Reduced-motion aware. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Opt in to the hidden-then-reveal state only now that we know this script is
  // running. Without this class the CSS leaves everything visible.
  function enableAnim() { document.documentElement.classList.add('mw-js'); }
  function disableAnim() { document.documentElement.classList.remove('mw-js'); }

  function showAll() {
    document.querySelectorAll('.mw-reveal').forEach(function (el) {
      el.classList.add('is-in');
    });
    document.querySelectorAll('.mw-grade').forEach(function (el) {
      el.classList.add('is-revealed');
    });
    document.querySelectorAll('[data-mw-count]').forEach(function (el) {
      el.textContent = el.getAttribute('data-mw-count') + (el.getAttribute('data-mw-suffix') || '');
    });
  }

  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-mw-count'));
    var suffix = el.getAttribute('data-mw-suffix') || '';
    var prefix = el.getAttribute('data-mw-prefix') || '';
    if (isNaN(target)) return;
    var decimals = (el.getAttribute('data-mw-count').split('.')[1] || '').length;
    var start = null;
    var dur = 1400;

    function frame(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      // easeOutExpo
      var eased = p === 1 ? 1 : 1 - Math.pow(2, -10 * p);
      var val = (target * eased).toFixed(decimals);
      el.textContent = prefix + val + suffix;
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* Stagger containers cascade their children in. Observed as a unit so the
     whole group animates together rather than each child racing the scroll. */
  function initStagger() {
    var groups = [].slice.call(document.querySelectorAll('[data-mw-stagger]'));
    if (!groups.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      groups.forEach(function (g) { g.classList.add('is-in'); });
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        obs.unobserve(en.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });

    groups.forEach(function (g) {
      // anything already on screen shows immediately, so nothing is stranded
      if (g.getBoundingClientRect().top < window.innerHeight) g.classList.add('is-in');
      else obs.observe(g);
    });

    // safety net: reveal anything still hidden after 3s
    setTimeout(function () {
      groups.forEach(function (g) {
        var r = g.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) g.classList.add('is-in');
      });
    }, 3000);
  }

  /* The compare slider nudges itself once, so people know it can be dragged. */
  function initCompareHint() {
    var el = document.querySelector('.mw-cmp');
    if (!el || reduced || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        obs.unobserve(en.target);
        setTimeout(function () {
          en.target.classList.add('is-hinting');
          setTimeout(function () { en.target.classList.remove('is-hinting'); }, 2100);
        }, 400);
      });
    }, { threshold: 0.5 });
    obs.observe(el);
    // a drag cancels the hint immediately
    el.addEventListener('pointerdown', function () { el.classList.remove('is-hinting'); });
  }

  /* The placard drifts against the scroll. Transform-only via a custom
     property, so the hover lift still composes rather than being clobbered. */
  function initCardParallax() {
    var card = document.querySelector('[data-mw-parallax]');
    if (!card || reduced) return;

    var depth = parseFloat(card.dataset.parallax || '0.08');
    var range = parseFloat(card.dataset.parallaxMax || '40');
    var target = 0, current = 0, ticking = false;

    function measure() {
      var hero = card.closest('.mw-mat');
      if (!hero) return;
      var r = hero.getBoundingClientRect();
      // 0 when the hero is centred, positive as it scrolls past
      var mid = r.top + r.height / 2 - window.innerHeight / 2;
      target = Math.max(-range, Math.min(range, -mid * depth));
    }

    function frame() {
      current += (target - current) * 0.12;          // ease toward the target
      card.style.setProperty('--par', current.toFixed(2) + 'px');
      if (Math.abs(target - current) > 0.05) requestAnimationFrame(frame);
      else ticking = false;
    }

    function onScroll() {
      measure();
      if (!ticking) { ticking = true; requestAnimationFrame(frame); }
    }

    measure();
    current = target;
    card.style.setProperty('--par', current.toFixed(2) + 'px');
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  function init() {
    initCardParallax();
    initStagger();
    initCompareHint();
    if (reduced || !('IntersectionObserver' in window)) {
      disableAnim();
      showAll();
      return;
    }

    enableAnim();

    // Anything already at or above the fold reveals immediately, so a visitor
    // landing on an anchor deep in the page never meets an invisible section.
    document.querySelectorAll('.mw-reveal').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in');
    });

    // Hard safety net: if anything is still hidden after 3s, show it.
    setTimeout(function () {
      document.querySelectorAll('.mw-reveal:not(.is-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
      });
    }, 3000);

    // Staggered section reveals
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-mw-delay') || '0', 10);
        setTimeout(function () { el.classList.add('is-in'); }, delay);
        revealObs.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    document.querySelectorAll('.mw-reveal').forEach(function (el) {
      revealObs.observe(el);
    });

    // Subgrade meter — bars grow from before-state to after-state
    var gradeObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var card = entry.target;
        setTimeout(function () { card.classList.add('is-revealed'); }, 260);
        gradeObs.unobserve(card);
      });
    }, { threshold: 0.35 });

    document.querySelectorAll('.mw-grade').forEach(function (el) {
      gradeObs.observe(el);
    });

    // Stat counters
    var countObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        countUp(entry.target);
        countObs.unobserve(entry.target);
      });
    }, { threshold: 0.5 });

    document.querySelectorAll('[data-mw-count]').forEach(function (el) {
      countObs.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run inside the Shopify theme editor when a section is re-rendered
  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 40);
  });
})();
